export const CREATED = "created";
export const PENDING = "pending";
export const ABANDONED = "abandoned";
export const EXPIRED = "expired";
export const CANCELED = "canceled";
export const COMPLETE = "complete";
export const ERROR = "error";
